module.exports = __webpack_public_path__ + "static/media/broken.65be772a.png";